import {
  BarChart3,
  Boxes,
  FilePlus2,
  LayoutDashboard,
  Store,
  Users,
  Wallet,
} from 'lucide-react';

export const NAV_SECTIONS = [
  {
    key: 'sectionMain',
    items: [
      { key: 'dashboard', path: '/', icon: LayoutDashboard, match: p => p === '/' },
      { key: 'checkout', path: '/checkout', icon: Wallet },
      {
        key: 'reports',
        path: '/reports',
        icon: BarChart3,
        match: p => p === '/reports' || /^\/reports\/\d+/.test(p),
      },
      { key: 'createReport', path: '/reports/create', icon: FilePlus2, match: p => p === '/reports/create' },
    ],
  },
  {
    key: 'sectionManage',
    items: [
      { key: 'products', path: '/products', icon: Boxes, admin: true },
      { key: 'branches', path: '/branches', icon: Store },
      { key: 'users', path: '/users', icon: Users, admin: true },
    ],
  },
];

// Pages an admin can grant to an employee; must match User::PAGES on the backend.
export const EMPLOYEE_PAGES = NAV_SECTIONS.flatMap(section => section.items).filter(item => !item.admin);

export const canSeePage = (isAdmin, pages, key) => isAdmin || !Array.isArray(pages) || pages.includes(key);

export const getFirstAllowedPath = (isAdmin, pages) =>
  EMPLOYEE_PAGES.find(item => canSeePage(isAdmin, pages, item.key))?.path ?? null;

export const isNavItemActive = (item, pathname) =>
  item.match ? item.match(pathname) : pathname === item.path || pathname.startsWith(`${item.path}/`);

export const getNavSections = (isAdmin, pages) =>
  NAV_SECTIONS.map(section => ({
    ...section,
    items: section.items.filter(item => (item.admin ? isAdmin : canSeePage(isAdmin, pages, item.key))),
  })).filter(section => section.items.length > 0);
